<template>
  <div class="card-section">
    <div class="section" :class="{ 'fewer-than-three': model.length < 3 }">
      <AdditionalResourceCard
        v-for="(card, i) in model"
        :key="i"
        :cardDetails="card"
      />
    </div>
  </div>
</template>

<script>
import AdditionalResourceCard from "@/components/ContentSite/Cards/AdditionalResourceCard.vue";

export default {
  name: "CardSection",
  components: {
    AdditionalResourceCard,
  },
  props: {
    model: Array,
  },
};
</script>

<style lang="scss" scoped>
.card-section {
  .section {
    margin: auto;
    padding-top: $spacer-five;

    &.fewer-than-three {
      text-align: center;
    }
  }
}
</style>
